import * as constants from 'redux/constants/shipping.constants';

export const getSingleQuote = (value, productId) => ({
  type: constants.SHIPPING_GET_SINGLE_QUOTE_REQUESTED,
  value,
  productId,
});

export const getCartQuote = (value, items) => ({
  type: constants.SHIPPING_GET_CART_QUOTE_REQUESTED,
  value,
  items,
});

export const getTrackingGuide = (value) => ({
  type: constants.SHIPPING_GET_TRACKING_GUIDE_REQUESTED,
  value,
});